$(function () {
  // Открытие мобильного меню
  $(".header__burger").on("click", function (e) {
    e.stopPropagation();
    $(".mobile-menu").addClass("active");
    $("body").addClass("mobile-menu-open");
    $(this).addClass("active");
  });

  // Закрытие мобильного меню по крестику
  $(document).on("click", ".mobile-menu__close", function () {
    $(".mobile-menu").removeClass("active");
    $("body").removeClass("mobile-menu-open");
    $(".header__burger").removeClass("active");
  });

  $(".mobile-menu__nav").on("click", "a", function () {
    $(".mobile-menu").removeClass("active");
    $("body").removeClass("mobile-menu-open");
    $(".header__burger").removeClass("active");
  }) 

  // Закрытие по клику вне меню
  $(document).on("click", function (e) {
    if (window.innerWidth < 1400) {
      if (
        !$(e.target).closest(".mobile-menu, .header__burger").length &&
        $(".mobile-menu").hasClass("active")
      ) {
        $(".mobile-menu").removeClass("active");
        $("body").removeClass("mobile-menu-open");
        $(".header__burger").removeClass("active");
      }
    }
  });

  // При ресайзе скрываем меню если >1400px
  $(window).on("resize", function () {
    if (window.innerWidth >= 1400) {
      $(".mobile-menu").removeClass("active");
      $("body").removeClass("mobile-menu-open");
      $(".header__burger").removeClass("active");
    }
  });

  if ($(this).scrollTop() > 0) {
    $(".header").addClass("bg");
  } else {
    $(".header").removeClass("bg");
  }
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 0) {
      $(".header").addClass("bg");
    } else {
      $(".header").removeClass("bg");
    }
  });
});
